import { render, staticRenderFns } from "./EditWardPage.vue?vue&type=template&id=3e435b17&"
import script from "./EditWardPage.vue?vue&type=script&lang=js&"
export * from "./EditWardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports